import React from 'react'
import Hero from '../2'
import { RealEstateDataPageComponentData } from 'types'

const Hero6 = ({ ...props }: RealEstateDataPageComponentData) => {
  return (
    <Hero
      {...props}
    />
  )
}

export default Hero6
